import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Avatar from '@mui/material/Avatar';
import { styled } from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import { BsTelephoneFill } from 'react-icons/bs';
import { MdEmail } from 'react-icons/md';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import logo_between from '../../public/assets/logo_between.png';
import Scorecard from '../../public/assets/Scorecard.svg';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.mode === 'black' ? 'black' : '#F5C11D',
    },
}));
const BorderLinearProgressTwo = styled(LinearProgress)(({ theme, barColor }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: barColor || (theme.palette.mode === 'black' ? 'black' : '#00BF2A'),
    },
}));
const progressBarDetails = [
    { score: '48 of 100', label: 'Bam Fam', date: 'Saturday, 3th Feb', value: 70, color: '#F5C11D', colors: '#f6d565' },
    { score: '45 of 100', label: 'Met With', date: 'Saturday, 3th Feb', value: 30, color: '#5bc02e', colors: '#5bc02e' },
    { score: '84 of 100', label: 'Offers', date: 'Saturday, 3th Feb', value: 80, color: '#4e97ff', colors: '#4e97ff' },
    { score: '46 of 100', label: 'Closing', date: 'Saturday, 3th Feb', value: 90, color: '#5379bd', colors: '#5379bd' },
    { score: '58 of 100', label: 'Answer Score', date: 'Saturday, 3th Feb', value: 50, color: '#e62e37', colors: '#e62e37' },
];
const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));
const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: '#44b700',
        color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            border: '1px solid currentColor',
            content: '""',
        },
    },
}));

const ICALeadProfileModal = ({ openAssignModal, handleCloseAssignModal }) => {
    const [expandedAssignment, setExpandedAssignment] = React.useState(false);
    const handleExpandAssignmentClick = () => {
        setExpandedAssignment(!expandedAssignment);
    };

    const [expanded, setExpanded] = React.useState(false);
    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    return (
        <div>
            <Modal
                open={openAssignModal}
                onClose={handleCloseAssignModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '10px',
                        width: 'auto',
                        height: '80%',
                        overflow: 'auto',
                    }}
                >
                    <IconButton style={{ position: 'absolute', top: '0px', right: '20px' }} onClick={handleCloseAssignModal}>
                        <CloseIcon />
                    </IconButton>
                    <Box style={{ display: 'flex', gap: '10px' }}>
                        <Box>
                            <StyledBadge overlap="circular" anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} variant="dot">
                                <Avatar alt="Remy Sharp" src="" />
                            </StyledBadge>
                        </Box>
                        <Box>
                            <Box style={{ display: 'flex', gap: '10px' }}>
                                <Box>
                                    <span style={{ fontSize: '25px', fontWeight: '700', color: '#414D55' }}>John</span>
                                </Box>
                                <Box></Box>
                            </Box>
                            <Box style={{ display: 'flex', gap: '20px' }}>
                                <Box>
                                    <Box style={{ display: 'flex', gap: '7px' }}>
                                        <div>
                                            <BsTelephoneFill style={{ fontSize: '13px', marginTop: '4px', cursor: 'pointer', color: 'black' }} />
                                        </div>
                                        <div style={{ width: '93px', height: 'auto' }}>
                                            <span style={{ fontSize: '12px', color: '#606060' }}>205 555-0100</span>
                                        </div>
                                    </Box>
                                </Box>
                                <Box>
                                    <Box style={{ display: 'flex', gap: '7px' }}>
                                        <Box>
                                            <MdEmail style={{ fontSize: '23px', cursor: 'pointer', color: 'black' }} />
                                        </Box>
                                        <Box>
                                            <span style={{ fontSize: '13px', color: '#606060' }}>test@yopmail.com</span>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    <Card sx={{ width: 545, mt: 2 }}>
                        <CardActions disableSpacing>
                            <Box style={{ display: 'flex' }}>
                                <Typography style={{ fontSize: '25px', fontWeight: '700', color: '#414D55' }}>Assigned by Me</Typography>
                            </Box>
                            <IconButton aria-label="share"></IconButton>
                            <ExpandMore
                                expand={expandedAssignment}
                                onClick={handleExpandAssignmentClick}
                                aria-expanded={expandedAssignment}
                                aria-label="show more"
                            >
                                <Typography style={{ color: '#5379BD', fontSize: '16px', fontWeight: '700' }}>View All</Typography>
                            </ExpandMore>
                        </CardActions>
                        <Box style={{ display: 'flex' }}>
                            <CardContent>
                                <Card sx={{ maxWidth: 245 }}>
                                    <CardActionArea>
                                        <div style={{ position: 'relative' }}>
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '53px',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    zIndex: 10,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    borderRadius: '4px',
                                                    padding: '5px',
                                                }}
                                            >
                                                <img src={logo_between} alt="" style={{ width: '44px', height: '44px' }} />
                                            </div>
                                        </div>
                                        <img
                                            src="https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=600x200&maptype=roadmap&center=41.711614,-74.012318&key=AIzaSyDj4s0gSPvrFI1xBvGGBAijVoluwpAhQyA"
                                            alt=""
                                        />
                                        <CardContent>
                                            <Typography style={{ fontSize: '25px', fontWeight: '700', color: '#414D55' }}>Charles Mathew</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Assigned by: David Berlin
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </CardContent>
                            <CardContent>
                                <Card sx={{ maxWidth: 245 }}>
                                    <CardActionArea>
                                        <div style={{ position: 'relative' }}>
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '53px',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    zIndex: 10,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    borderRadius: '4px',
                                                    padding: '5px',
                                                }}
                                            >
                                                <img src={logo_between} alt="" style={{ width: '44px', height: '44px' }} />
                                            </div>
                                        </div>
                                        <img
                                            src="https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=600x200&maptype=roadmap&center=41.711614,-74.012318&key=AIzaSyDj4s0gSPvrFI1xBvGGBAijVoluwpAhQyA"
                                            alt=""
                                        />
                                        <CardContent>
                                            <Typography style={{ fontSize: '25px', fontWeight: '700', color: '#414D55' }}>Charles Mathew</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Assigned by: David Berlin
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </CardContent>
                        </Box>
                        <Collapse in={expandedAssignment} timeout="auto" unmountOnExit>
                            <CardContent>
                                <Card sx={{ maxWidth: 245 }}>
                                    <CardActionArea>
                                        <div style={{ position: 'relative' }}>
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '53px',
                                                    left: '50%',
                                                    transform: 'translateX(-50%)',
                                                    zIndex: 10,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    borderRadius: '4px',
                                                    padding: '5px',
                                                }}
                                            >
                                                <img src={logo_between} alt="" style={{ width: '44px', height: '44px' }} />
                                            </div>
                                        </div>
                                        <img
                                            src="https://maps.googleapis.com/maps/api/staticmap?zoom=13&size=600x200&maptype=roadmap&center=41.711614,-74.012318&key=AIzaSyDj4s0gSPvrFI1xBvGGBAijVoluwpAhQyA"
                                            alt=""
                                        />
                                        <CardContent>
                                            <Typography style={{ fontSize: '25px', fontWeight: '700', color: '#414D55' }}>Charles Mathew</Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                Assigned by: David Berlin
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </CardContent>
                        </Collapse>
                    </Card>

                    <Card sx={{ width: 545, mt: 2 }}>
                        <CardActions disableSpacing>
                            <Box style={{ display: 'flex', margin: '15px' }}>
                                <img src={Scorecard} alt="" style={{ width: '29px' }} />
                                <Typography style={{ fontSize: '25px', fontWeight: '700', color: '#414D55' }}>Score Card</Typography>
                            </Box>
                            <IconButton aria-label="share"></IconButton>
                            <ExpandMore expand={expanded} onClick={handleExpandClick} aria-expanded={expanded} aria-label="show more">
                                <Typography style={{ color: '#5379BD', fontSize: '16px', fontWeight: '700' }}>View All</Typography>
                            </ExpandMore>
                        </CardActions>
                        <CardContent>
                            <Box style={{ margin: '20px' }}>
                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                    <ButtonGroup
                                        aria-label="Basic button group"
                                        sx={{
                                            '& .MuiButtonGroup-grouped': {
                                                borderRadius: 0,
                                            },
                                            '& .MuiButtonGroup-grouped:first-of-type': {
                                                borderTopLeftRadius: '10px',
                                                borderBottomLeftRadius: '10px',
                                            },
                                            '& .MuiButtonGroup-grouped:last-of-type': {
                                                borderTopRightRadius: '10px',
                                                borderBottomRightRadius: '10px',
                                            },
                                        }}
                                    >
                                        <Button
                                            style={{
                                                width: '100px',

                                                backgroundColor: '#5379BD',
                                                color: 'white',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            Day
                                        </Button>
                                        <Button
                                            style={{
                                                width: '76px',
                                                backgroundColor: 'white',
                                                color: '#5379BD',
                                                border: '1px solid #5379BD',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            Week
                                        </Button>
                                        <Button
                                            style={{
                                                width: '76px',
                                                backgroundColor: 'white',
                                                color: '#5379BD',
                                                border: '1px solid #5379BD',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            Month
                                        </Button>
                                    </ButtonGroup>
                                </Box>

                                <Box style={{ display: 'flex', justifyContent: 'space-between', margin: '20px' }}>
                                    <Box style={{ display: 'grid' }}>
                                        <Typography style={{ fontSize: '17px', color: '#414D55' }}>48 of 100</Typography>
                                        <Typography style={{ fontSize: '12px', color: '#898989' }}>4th week</Typography>
                                    </Box>
                                    <Box style={{ display: 'grid' }}>
                                        <Box>
                                            <Typography style={{ color: '#F5C11D', fontSize: '17px' }}>Bam Fam</Typography>
                                        </Box>
                                        <Box>
                                            <Typography style={{ color: '#898989', fontSize: '12px' }}>Saturday, 3th Feb</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                                <Box style={{ margin: '20px' }}>
                                    <BorderLinearProgress variant="determinate" sx={{ color: '#F5C11D' }} value={30} />
                                </Box>
                            </Box>
                        </CardContent>

                        <Collapse in={expanded} timeout="auto" unmountOnExit>
                            <CardContent>
                                {/* Bam Fam */}
                                <Box>
                                    <Box style={{ margin: '20px' }}>
                                        <Typography style={{ marginLeft: '12px', fontSize: '20px', fontWeight: '700', color: '#414D55' }}>
                                            Score of Agent
                                        </Typography>
                                    </Box>
                                </Box>
                                {/* Meet With */}
                                <Box>
                                    <Box style={{ margin: '20px' }}>
                                        {progressBarDetails.map((detail, index) => (
                                            <Box key={index} style={{ margin: '20px' }}>
                                                <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Box>
                                                        <Typography style={{ fontSize: '17px', color: '#414D55' }}>{detail.score}</Typography>
                                                        <Typography
                                                            style={{
                                                                fontSize: '12px',
                                                                color: '#898989',
                                                            }}
                                                        >
                                                            4th week
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <Typography style={{ color: detail.colors, fontSize: '17px' }}>{detail.label}</Typography>

                                                        <Typography style={{ color: '#898989', fontSize: '12px' }}>{detail.date}</Typography>
                                                    </Box>
                                                </Box>
                                                <Box>
                                                    <BorderLinearProgressTwo variant="determinate" value={detail.value} barColor={detail.color} />
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </CardContent>
                        </Collapse>
                    </Card>
                </div>
            </Modal>
        </div>
    );
};
export default ICALeadProfileModal;
